module.exports = {
  accordion:  require('./accordion'),
  banner:     require('./banner'),
  footer:     require('./footer'),
  navigation: require('./navigation'),
  password:   require('./password'),
  search:     require('./search'),
  skipnav:    require('./skipnav'),
  validator:  require('./validator'),
};

